(function() {
  'use strict';

  angular
    .module('newDocument.boxViewer', [])
    .service('mfBoxPluginRegister', mfBoxPluginRegister)
    .factory('MFBoxPlugin', MFBoxPlugin)
    .controller('BoxViewerController', BoxViewerController)
    .directive('mfBoxViewer', mfBoxViewer);

  mfBoxPluginRegister.$inject = ['Crocodoc', 'MFBoxPlugin'];
  MFBoxPlugin.$inject = [];
  BoxViewerController.$inject = ['$scope', 'Crocodoc', 'mfBoxPluginRegister'];
  mfBoxViewer.$inject = [];

  function mfBoxPluginRegister(Crocodoc, MFBoxPlugin) {
    Crocodoc.addPlugin('mf-box-plugin', MFBoxPlugin);
  }

  function MFBoxPlugin() {
    var messages = ['fail', 'asseterror', 'pagefail'],
      config;

    function service(scope) {
      return {
        messages: messages,
        onmessage: onmessage,
        init: init,
        destroy: destroy
      }
    }

    function onmessage(name, data) {
      dispatchError(name);
    }

    // init is called with the plugin's config when the viewer is loaded
    function init(pluginConfig) {
      config = pluginConfig;
    }

    function dispatchError(name) {
      if (typeof config.onerror === 'function') {
        config.onerror(name);
        return;
      }
      throw new Error('BoxViewer: ' + name);
    }

    // destroy is called automatically when the viewer is destroyed
    function destroy() {
      // there's nothing to cleanup in this plugin, but this
      // would be a good place to do so otherwise
      //console.log('goodbye cruel world');
    }

    return service;
  }

  function BoxViewerController($scope, Crocodoc, mfBoxPluginRegister) {
    // leave mfBoxPluginConfig so it will initialize
    var self = this,
      viewer = null,
      scope = $scope.$new();

    this.init = function(element) {
      self.$element = element;
    };

    this.loadViewer = function(viewerState) {
      if (!viewerState.url) {
        throw new Error('BoxViewer: No url specified.');
      }

      viewer = Crocodoc.createViewer(self.$element, viewerState);
      viewer.load();
    };

    $scope.$on('$destroy', function() {
      if (viewer)
        viewer.destroy();
      scope.$destroy();
    });
  }

  function mfBoxViewer() {
    return {
      scope: {
        mfBoxViewer: '='
      },
      controller: 'BoxViewerController',
      link: function(scope, element, attrs, boxViewerCtrl) {
        boxViewerCtrl.init(element);

        scope.$watch('mfBoxViewer', function(value) {
          if (!value)
            return;

          boxViewerCtrl.loadViewer(value);
        });
      }
    };
  }
})();
